export default {
  main: "Main number",
  mobile: "Mobile number",
}
